import AppInputField from "components/shared/FormComponents/AppInputField";
import { INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS } from "config/constants";
import { formatString } from "helpers/common";

const QuestionWithRadio = ({ question, fieldName }) => {
  const options = question?.question_radio_tag;
  const inputLabels = question?.question_dd_labels;

  return (
    <>
      {options?.length > 0 && (
        <div className="radio-inputs">
          {options.map((option, index) => (
            <label
              key={index}
              className="d-flex gap-10 py-1"
            >
              <AppInputField
                type="radio"
                name={`${fieldName}.other_details.radio_tag`}
                value={option}
              />
              {formatString(option, false)}
            </label>
          ))}
        </div>
      )}
      {inputLabels?.length > 0 && (
        <div className="text-inputs py-2">
          {inputLabels.map((label, index) => (
            <div className="d-flex align-items-center gap-10 pb-3">
              <label
                key={index}
                style={{ width: "50%" }}
              >
                {formatString(label, false)}
              </label>
              <AppInputField
                name={`${fieldName}.other_details.dd_labels.${label}`}
              />
            </div>
          ))}
        </div>
      )}
      <AppInputField
        name={`${fieldName}.answer`}
        placeholder={question.template}
        fieldType={"textarea"}
        rows={4}
        className="form-control rounded-3 bg-white pt-5 is-resizable-textarea"
        style={{ minHeight: "calc(8em + 0.75rem + calc(var(--bs-border-width) * 2)) !important" }}
      />
    </>
  )
}

export default QuestionWithRadio;